import React from "react";
import { Container } from "./styles";
import { MdEdit } from "react-icons/md";

export default function NoticeBlock({ title, id }) {
	return (
		<Container>
			<a className="notice-btn" href="">
				<div className="content">
					<h3 title={title}>{title}</h3>
					<div className="icon">
						<MdEdit />
					</div>
				</div>
			</a>
		</Container>
	);
}
